import * as Constants from '../constants/';
import _ from 'lodash';

const initialState = {
  isLoading: true,
  flags: {}
};

function toFlags(flags) {
  if (!flags) {
    return {};
  }

  const canReadOnlyFlag = flags.find(flag => flag.name === 'read_only');
  const isReadOnlyFlag = flags.find(flag => flag.name === 'is_read_only');

  const canReadonly = canReadOnlyFlag && canReadOnlyFlag.active;
  const isReadonly = canReadonly && isReadOnlyFlag && isReadOnlyFlag.active;

  const flagObj = {
    canReadonly,
    isReadonly
  };

  Constants.FLAGS.forEach(
    flagName =>
      (flagObj[_.camelCase(flagName)] =
        flags.find(flag => flag.name === flagName)?.active || false)
  );

  return flagObj;
}

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_FLAGS:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_FLAGS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        flags: toFlags(action.data.flags)
      };

    default:
      return state;
  }
}
